import React from 'react';
import { useState, useEffect } from 'react';
import { Row, Col, Space, Select, Spin } from 'antd';
import { PageContentLayout, PageHeaderLayout } from '../../shared/layout';
import { FormOutlined, ShareAltOutlined, ReadOutlined } from '@ant-design/icons';
import { withRouter } from 'react-router-dom';
import EditorialTable from './components/EditorialTable';
import { ButtonText } from '../../shared/globalStyling/styledText';
import Button from '../../shared/globalStyling/Button';
import LaunchEditorial from './components/LaunchEditorial';
import ShareEditorial from './components/ShareEditorial';
import FilterBar from './components/FilterBar';
import { useTagContext } from '../../../core/components/tags/useTagContext';

const EditorialMainView = ({
  history,
  data,
  location,
  current,
  total,
  pageSize,
  isSelfService,
  onCreateEditorial,
  onShareEditorial,
  orgsSharing,
  publishers,
  selectedPublisher,
  currentOrgId,
  getFilteredOrgsRow,
  filteredLocations,
  filteredAudiences,
  google,
  orgLevel,
}) => {
  const [openLaunch, setOpenLaunch] = useState(false);
  const [openShare, setOpenShare] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    if (!location.search) {
      const savedPublisher = sessionStorage.getItem('editorialMainPublisher');
      if (savedPublisher && savedPublisher !== 'All Publisher') {
        const params = new URLSearchParams();
        params.append('publisher', savedPublisher);
        history.replace(`/publisher/main/1?${params.toString()}`);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const {
    fetchTags,
    tags,
    loadingTags,
    getBasicTagActivity,
    basicTagActivity,
    tagActivityLoading,
    tagActivityError,
    clearBasicTagActivity,
  } = useTagContext();

  const onFetchTags = () => {
    fetchTags({
      variables: {
        where: {
          orgs_some: {
            OR: [
              {
                parentOrg_some: {
                  id: currentOrgId,
                },
              },
              {
                id: currentOrgId,
              },
            ],
          },
          OR: [{ isDisabled: false }, { isDisabled: null }],
        },
      },
    });
  };

  useEffect(() => {
    onFetchTags();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onRowChange = (selectedRowKeys, selectedRows) => {
    setSelectedRowKeys(selectedRowKeys);
    setSelectedRows(selectedRows);
  };

  return (
    <React.Fragment>
      <LaunchEditorial
        tags={tags}
        open={openLaunch}
        onCreate={(values) => {
          setOpenLaunch(false);
          onCreateEditorial(values);
        }}
        onCancel={() => {
          setOpenLaunch(false);
        }}
        currentOrgId={currentOrgId}
        filteredLocations={filteredLocations}
        filteredAudiences={filteredAudiences}
        google={google}
        isSelfService={isSelfService}
        onFetchTags={onFetchTags}
        loadingTags={loadingTags}
        getBasicTagActivity={getBasicTagActivity}
        basicTagActivity={basicTagActivity}
        tagActivityLoading={tagActivityLoading}
        tagActivityError={tagActivityError}
        clearBasicTagActivity={clearBasicTagActivity}
      />
      <ShareEditorial
        open={openShare}
        orgs={orgsSharing}
        selectedRows={selectedRows}
        getFilteredOrgsRow={getFilteredOrgsRow}
        onCancel={() => {
          setOpenShare(false);
        }}
        onCreate={(values) => {
          setOpenShare(false);
          onShareEditorial(values);
          setSelectedRows([]);
          setSelectedRowKeys([]);
        }}
      />
      <PageHeaderLayout
        title={'Publisher'}
        titleIcon={
          <ReadOutlined
            style={{
              marginRight: '10px',
              color: 'lightgrey',
              fontSize: 20,
            }}
          />
        }
        titleExtra={
          <Select
            defaultValue={'All Publisher'}
            style={{ width: '200px' }}
            onChange={(val) => {
              const params = new URLSearchParams(location.search);
              if (params.get('publisher')) {
                params.delete('publisher');
              }
              if (val !== 'All Publisher') {
                params.append('publisher', val);
                sessionStorage.setItem('editorialMainPublisher', val);
              } else {
                sessionStorage.setItem('editorialMainPublisher', 'All Publisher');
              }

              history.push(`/publisher/main/1?${params.toString()}`);
            }}
            value={selectedPublisher ? selectedPublisher : 'All Publisher'}
          >
            <Select.Option key="all" value="All Publisher">
              All Publisher
            </Select.Option>
            {publishers.map((publisher) => {
              return (
                <Select.Option key={publisher.id} value={publisher.id}>
                  {publisher.name}
                </Select.Option>
              );
            })}
          </Select>
        }
        rightContent={
          <Row>
            <Col className="ant-row-flex-column ant-row-align-items-center">
              {isSelfService && (
                <Button
                  onClick={() => {
                    setOpenLaunch(!openLaunch);
                  }}
                  type="primary"
                  ghost
                  icon={<FormOutlined />}
                >
                  <ButtonText text={'Add Funnel'} />
                </Button>
              )}
            </Col>
          </Row>
        }
      />
      <PageContentLayout>
        <PageHeaderLayout
          title={'Publisher Funnels'}
          rightContent={
            <Row align="middle" justify="end">
              <Col flex="auto">
                <Space>
                  <Button
                    icon={<ShareAltOutlined />}
                    style={{
                      fontSize: '14px',
                      width: '175px',
                      marginRight: '10px',
                      height: '36px',
                      margin: '12px 10px 12px 0',
                    }}
                    shape="round"
                    type="primary"
                    disabled={selectedRowKeys.length === 0}
                    ghost
                    onClick={() => {
                      setOpenShare(!openShare);
                    }}
                  >
                    Share Editorial
                  </Button>
                </Space>
              </Col>
            </Row>
          }
        />
        <FilterBar orgLevel={orgLevel} />
        <EditorialTable
          data={data}
          history={history}
          selectedRowKeys={selectedRowKeys}
          onRowChange={onRowChange}
          current={current}
          location={location}
          pageSize={pageSize}
          total={total}
        />
      </PageContentLayout>
    </React.Fragment>
  );
};

export default withRouter(EditorialMainView);
